







































































































import { Vue, Component } from "vue-property-decorator";
import Rep from "@/components/Sidebar/Rep/Rep.vue";
import { StoreModule } from "@/store/types";
import { RepGetters } from "@/store/modules/rep/types";
import { UserGetters } from "@/store/modules/user/types";
import { namespace } from "vuex-class";
import ModalRep from "@/components/Modal/ModalRep.vue";
import { User } from "@/models/user_schema";
import SalesRegionMap from "@/models/map/region";
import { SalesRegions, SalesRegionsStringType } from "@/models/map/region_type";
import Search from "@/components/Sidebar/Search.vue";
import { Roles } from "@/models/roles";
import UIkit from "uikit";
import simplebar from "simplebar-vue";
import { EventBus } from "@/events/index";
import { CustomerGetters } from "@/store/modules/customer/types";
import { GlobalActions, GlobalGetters } from "@/store/modules/global/types";
import { Layers } from "@/models/map/layers";
import { ExportActions } from "@/store/modules/export/types";
import { CustomerType } from "@/models/customer";

@Component({
  components: {
    Rep,
    ModalRep,
    Search,
    simplebar,
  },
})
export default class RepList extends Vue {
  protected SalesRegionMap = SalesRegionMap;
  protected region: SalesRegions["string"] | "" = "";
  protected sort = "asc";
  protected searchTerm = "";
  protected Roles = Roles;
    @(namespace(StoreModule.Global).Action(GlobalActions.AddLoading)) setLoading;
  @(namespace(StoreModule.Rep).Getter(RepGetters.GetAllReps)) reps;
  @(namespace(StoreModule.Customer).Getter(CustomerGetters.GetAllCustomers))
  customers;
  @(namespace(StoreModule.User).Getter(UserGetters.GetRole)) role;
    @(namespace(StoreModule.User).Getter(UserGetters.GetUser)) user;
  @(namespace(StoreModule.Export).Action(ExportActions.AddExportFilters))
  addExportFilters;
  @(namespace(StoreModule.Global).Getter(GlobalGetters.GetActiveView))
  activeView;

  created() {
    EventBus.$on("getExportData", () => {
      this.addExportFilters({
        data: "customer",
        region: this.region,
        customer_type: "",
        status: "",
        layer: this.getActiveView(),
      });
    });
  }

  beforeDestroy() {
    EventBus.$off('getExportData');
  }


  mounted() {
    if (this.role === Roles.SalesRep) {
      this.$router.replace('/reps/' + 'me' + '/?region=' + this.formatSalesRegion(this.user.rep_info.sales_region))
    }
    if (this.$route.query.region) {
      this.region = this.$route.query.region as SalesRegions["string"];
      this.filterFooterData(this.region);
    } else {
      this.filterFooterData();
    }
  }

  public formatSalesRegion = (str: string): SalesRegionsStringType => {
  if (str.includes('-')) {
        return str.split('-').map((s) => s.charAt(0).toUpperCase() + s.substring(1)).join('-') as SalesRegionsStringType;
  } else {
        return str.split(' ').map((s) => s.charAt(0).toUpperCase() + s.substring(1)).join(' ') as SalesRegionsStringType;
  }
}

  public getActiveView(): object {
    let layer = {};
    if (this.activeView === Layers.Contract) {
      layer = { handle: Layers.Contract, displayName: "Contract Dealers" };
    } else if (this.activeView === Layers.Beach) {
      layer = { handle: Layers.Beach, displayName: "Beach Concessionaires" };
    } else {
      layer = { handle: Layers.Customers, displayName: "Retail & Design" };
    }
    return layer;
  }

  protected filterFooterData(region?: SalesRegions["string"]): void {
    if (region) {
      const regionArray = this.customers.filter((customer) => {
        return (
          customer.sales_region === region &&
          (customer.customer_type === CustomerType.Customer ||
            customer.customer_type === CustomerType.Designer)
        );
      });
      EventBus.$emit("sendFooterData", regionArray);
    } else {
      const regionArray = this.customers.filter((customer) => {
        return (
          customer.customer_type === CustomerType.Customer ||
          customer.customer_type === CustomerType.Designer
        );
      });
      EventBus.$emit("sendFooterData", regionArray);
    }
  }

  public goBackToRepList(): void {
    this.setLoading(true)
    this.$router.push({
      path: "/",
    });
    setTimeout(() => this.setLoading(false), 200)
  }

  public triggerSearch(searchTerm: string) {
    this.searchTerm = searchTerm;
  }

  get regionList(): string[] {
    const values: string[] = [];
    for (const [key, value] of this.SalesRegionMap.entries()) {
      values.push(value);
    }
    return values;
  }

  public flyToFull(): void {
    this.region = "";
    if (this.$route.query.region) {
      this.$router.push({
        path: "/",
      });
    }
  }

  public flyToRegion(): void {
    if (this.region != this.$route.query.region)
      this.$router.push({
        path: "/",
        query: { region: this.region },
      });
  }

  public selectRegion(region: SalesRegions["string"] | "") {
    this.region = region;
    if (!region) {
      this.goBackToRepList();
    } else {
      this.flyToRegion();
    }
  }

  public get filteredReps(): User[] {
    let repArray = this.reps;
    if (this.region) {
      repArray = this.reps.filter((rep) => {
        return (
          rep.rep_info.sales_region.toLowerCase() === this.region.toLowerCase()
        );
      });
    }
    if (this.searchTerm) {
      repArray = repArray.filter((rep) => {
        const term = this.searchTerm.toLowerCase();
        return (
          rep.last_name.toLowerCase().includes(term) ||
          rep.first_name.toLowerCase().includes(term)
        );
      });
    }
    if (this.sort === "asc") {
      repArray.sort((first, second) => {
        if (first.last_name < second.last_name) return -1;
        if (first.last_name > second.last_name) return 1;
        if (first.first_name < second.first_name) return -1;
        if (first.first_name > second.first_name) return 1;
      });
    }
    if (this.sort === "desc") {
      repArray.sort((first, second) => {
        if (first.last_name < second.last_name) return 1;
        if (first.last_name > second.last_name) return -1;
        if (first.first_name < second.first_name) return 1;
        if (first.first_name > second.first_name) return -1;
      });
    }
    return repArray;
  }
  

  public selectSort(sort: "asc" | "desc") {
    UIkit.dropdown(this.$refs.sort).hide(false);
    this.sort = sort;
  }

  protected triggerAddRep() {
    this.$modal.show(
      ModalRep,
      {},
      { adaptive: true, width: 860, height: "auto", scrollable: true }
    );
  }
}
